/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_IntelligenceInputs */

const en_nav_intelligence = /** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel`)
};

const id_nav_intelligence = /** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel`)
};

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const es_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const fr_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const de_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const ja_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const zh_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const ar_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const it_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const ru_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const pt_nav_intelligence = en_nav_intelligence;

/** @type {(inputs: Nav_IntelligenceInputs) => LocalizedString} */
const ko_nav_intelligence = en_nav_intelligence;

/**
* | output |
* | --- |
* | "Intel" |
*
* @param {Nav_IntelligenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_intelligence = /** @type {((inputs?: Nav_IntelligenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_IntelligenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_intelligence(inputs)
	if (locale === "es") return es_nav_intelligence(inputs)
	if (locale === "fr") return fr_nav_intelligence(inputs)
	if (locale === "de") return de_nav_intelligence(inputs)
	if (locale === "ja") return ja_nav_intelligence(inputs)
	if (locale === "zh") return zh_nav_intelligence(inputs)
	if (locale === "ar") return ar_nav_intelligence(inputs)
	if (locale === "id") return id_nav_intelligence(inputs)
	if (locale === "it") return it_nav_intelligence(inputs)
	if (locale === "ru") return ru_nav_intelligence(inputs)
	if (locale === "pt") return pt_nav_intelligence(inputs)
	return ko_nav_intelligence(inputs)
});